import { inject, Injectable, signal } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CurrentUrlService {
  readonly #router = inject(Router);
  readonly currentUrl = signal(this.#router.url);

  constructor() {
    this.#router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl.set(event.urlAfterRedirects || event.url);
      });
  }
}
